module.exports = __webpack_public_path__ + "static/media/not-good-v2.981edf35.svg";